export default function onArrowDown(event, editor, next) {
  if (!editor.query('isAtLastLineOfBlock')) {
    return next();
  }

  event.preventDefault();
  editor.moveToCellBelow();
  return false;
}